<template>
    <div class="container">
        <b-modal
            :model-value="modalCrear"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.vigencia }}</label>
                        <input
                            v-model="form.vigencia"
                            type="month"
                            class="reset-input"
                        >

                        <label>{{ labels.activoCorriente }}</label>
                        <b-form-input
                            v-model="form.activoCorriente"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.activoNoCorriente }}</label>
                        <b-form-input
                            v-model="form.activoNoCorriente"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.totalActivo }}</label>
                        <b-form-input
                            v-model="form.totalActivo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.pasivoCorriente }}</label>
                        <b-form-input
                            v-model="form.pasivoCorriente"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.pasivoNoCorriente }}</label>
                        <b-form-input
                            v-model="form.pasivoNoCorriente"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.totalPasivo }}</label>
                        <b-form-input
                            v-model="form.totalPasivo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.utilidadAcumulada }}</label>
                        <b-form-input
                            v-model="form.utilidadAcumulada"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.totalPatrimonio }}</label>
                        <b-form-input
                            v-model="form.totalPatrimonio"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.ebit }}</label>
                        <b-form-input
                            v-model="form.ebit"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarZscore()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
    </div>
</template>

<script>
import InformacionFinanciera from '../../../services/InformacionFinanciera' 

export default {
    name : 'Crear',
    props:{
        modalCrear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form : {
                vigencia : '',
                activoCorriente : '',
                activoNoCorriente : '',
                totalActivo : '',
                pasivoCorriente : '',
                pasivoNoCorriente : '',
                totalPasivo : '',
                utilidadAcumulada : '',
                totalPatrimonio : '',
                ebit : '',
            }
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : 'Crear información financiera',
                    formInfoTitle: "Datos de la información financiera",
                    formInfoSubtitle: "Completa la información y guarda los datos.",
                    save : 'Guardar',
                    close : 'Cerrar',
                    vigencia : 'Vigencia',
                    activoCorriente : 'Activo corriente',
                    activoNoCorriente : 'Activo no corriente',
                    totalActivo : 'Total activo',
                    pasivoCorriente : 'Pasivo corriente',
                    pasivoNoCorriente : 'Pasivo no corriente',
                    totalPasivo : 'Total pasivo',
                    utilidadAcumulada : 'Utilidad acumulada',
                    totalPatrimonio : 'Total patrimonio',
                    ebit : 'EBIT',
                }
            }else{
                return {
                    title : 'Create financial information',
                    formInfoTitle: "Financial information data",
                    formInfoSubtitle: "Complete the information and save the data.",
                    save : 'Save',
                    close : 'Close',
                    vigencia : 'Validity',
                    activoCorriente : 'Current assets',
                    activoNoCorriente : 'Non-current asset',
                    totalActivo : 'Total assets',
                    pasivoCorriente : 'Passive current',
                    pasivoNoCorriente : 'Passive Non-Current',
                    totalPasivo : 'Total liabilities',
                    utilidadAcumulada : 'Accumulated profit',
                    totalPatrimonio : 'Total Assets',
                    ebit : 'EBIT',
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.cleanInp();
            this.$emit('cierraModal',false) 
        },
        guardarZscore(){

            if (!this.form.vigencia || 
                !this.form.activoCorriente || 
                !this.form.activoNoCorriente || 
                !this.form.totalActivo ||
                !this.form.pasivoCorriente ||
                !this.form.pasivoNoCorriente ||
                !this.form.totalPasivo ||
                !this.form.utilidadAcumulada ||
                !this.form.totalPatrimonio ||
                !this.form.ebit
            ) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                'vigencia' : this.form.vigencia, 
                'activoCorriente' : this.form.activoCorriente, 
                'activoNoCorriente' : this.form.activoNoCorriente, 
                'totalActivo' : this.form.totalActivo, 
                'pasivoCorriente' : this.form.pasivoCorriente, 
                'pasivoNoCorriente' : this.form.pasivoNoCorriente, 
                'totalPasivo' : this.form.totalPasivo, 
                'utilidadAcumulada' : this.form.utilidadAcumulada, 
                'totalPatrimonio' : this.form.totalPatrimonio, 
                'ebit' : this.form.ebit, 
                'idUser' : this.$store.state.userId 
            }
            // console.log(info); 

            InformacionFinanciera.createInformacionFinaciera(info) 
            .then((res) => { 
                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado");
                    this.cierraModal();
                }
            })
            .catch((err) => console.log(err)) 
            
        },
        cleanInp(){
            this.form.vigencia = "";
            this.form.activoCorriente = "";
            this.form.activoNoCorriente = "";
            this.form.totalActivo = "";
            this.form.pasivoCorriente = "";
            this.form.pasivoNoCorriente = "";
            this.form.totalPasivo = "";
            this.form.utilidadAcumulada = "";
            this.form.totalPatrimonio = "";
            this.form.ebit = "";
        }
    }
}
</script>

<style>

</style>
